import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/media';

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-colors hover:border-primary-300/60 sm:flex-row"
    >
      <div className="h-48 w-full shrink-0 overflow-hidden bg-background-200 sm:h-auto sm:w-64 md:w-80">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 黄色影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col justify-between gap-3 p-4 md:p-6">
        <div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-accent-100 px-2.5 py-1 text-accent-900">{item.category}</span>
            <span>{item.date}</span>
            <span className="hidden sm:inline">·</span>
            <span className="hidden sm:inline">{item.author}</span>
          </div>
          <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-500 md:text-lg">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {item.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              #{tag}
            </span>
          ))}
          <span className="ml-auto hidden items-center gap-1 text-sm text-primary-500 group-hover:gap-2 sm:flex">
            阅读全文
            <i className="ri-arrow-right-line transition-all"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}